module.exports = __webpack_public_path__ + "assets/webgl/FloorPattern.jpg.astc.79c02068.ktx";